export default __webpack_public_path__ + "static/media/az.488bc6cd.svg";